"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Calendar.ISO", "zero_pad", 2, "private", [{params: (context) => [Type.variablePattern("val_0"), Type.variablePattern("count_1")], guards: [(context) => (Interpreter.toBoolean(Erlang[">=/2"](context.vars.val_0, Type.integer(0n))) ? Erlang["=</2"](context.vars.count_1, Type.integer(6n)) : Type.boolean(false))], body: (context) => {
Interpreter.matchOperator(Erlang["integer_to_binary/1"](context.vars.val_0), Type.variablePattern("num_2"), context);
Interpreter.updateVarsToMatchedValues(context);
return Interpreter.case(Erlang["max/2"](Erlang["-/2"](context.vars.count_1, Erlang["byte_size/1"](context.vars.num_2)), Type.integer(0n)), [{match: Type.integer(0n), guards: [], body: (context) => {
return context.vars.num_2;
}}, {match: Type.integer(1n), guards: [], body: (context) => {
return Interpreter.consOperator(Type.bitstring("0"), context.vars.num_2);
}}, {match: Type.integer(2n), guards: [], body: (context) => {
return Interpreter.consOperator(Type.bitstring("00"), context.vars.num_2);
}}, {match: Type.integer(3n), guards: [], body: (context) => {
return Interpreter.consOperator(Type.bitstring("000"), context.vars.num_2);
}}, {match: Type.integer(4n), guards: [], body: (context) => {
return Interpreter.consOperator(Type.bitstring("0000"), context.vars.num_2);
}}, {match: Type.integer(5n), guards: [], body: (context) => {
return Interpreter.consOperator(Type.bitstring("00000"), context.vars.num_2);
}}], context);
}}, {params: (context) => [Type.variablePattern("val_0"), Type.variablePattern("count_1")], guards: [], body: (context) => {
return Interpreter.consOperator(Type.integer(45n), Elixir_Calendar_ISO["zero_pad/2"](Erlang["-/1"](context.vars.val_0), context.vars.count_1));
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));